<button (click)="fullScreen()" mat-icon-button class="cursor-pointer" *ngIf="isAndroidOrDesktop$ | async">
    <sim-icon color="var(--text-icon)" sizeType="medium" *ngIf="!isFullScreen" icon="fullscreen" />
    <sim-icon color="var(--text-icon)" sizeType="medium" *ngIf="isFullScreen" icon="fullscreen_exit_dark" />
</button>
